export const userConstants = {
  odcInternalUserId: '5b1dd496-f7a4-4011-b4e2-987a41c131f4',
  defaultInternalOrgId: 'default-internal'
};
